import { Button, Card, Typography } from '@sl/react-datafabric-components';
import { useNavigate } from 'react-router-dom';

export function PaymentCancel() {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate('/subscriptions/subscribe', { replace: true });
  };

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  return (
    <Card className='w-full max-w-md'>
      <div className='text-center p-6'>
        {/* Icon */}
        <div className='mb-4'>
          <i className='pi pi-times-circle text-6xl text-red-500'></i>
        </div>

        {/* Title */}
        <Typography className='text-2xl font-bold text-900'>
          Payment Failed
        </Typography>

        {/* Description */}
        <Typography className='text-600 line-height-3 mb-8'>
          Your payment was canceled. No charges have been made to your account.
        </Typography>
        {/* Action Buttons */}
        <div className='flex flex-column gap-3 align-items-center'>
          <Button
            label='Try Again'
            icon='pi pi-refresh'
            onClick={handleTryAgain}
            severity='info'
          />
          <Button
            label='Go Home'
            icon='pi pi-home'
            onClick={handleGoHome}
            outlined
          />
        </div>
      </div>
    </Card>
  );
}
